import React from 'react'

const PeopleIcon = ({ className, size = 24, color = 'currentColor' }) => {
  return (
    <svg 
      className={className}
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="people-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(255, 100, 200, 1)" />
          <stop offset="100%" stopColor="rgba(200, 100, 255, 1)" />
        </linearGradient>
        <filter id="people-glow">
          <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      <circle cx="12" cy="8" r="3" stroke="url(#people-gradient)" strokeWidth="2" filter="url(#people-glow)" />
      <path 
        d="M6 21V19C6 16.79 7.79 15 10 15H14C16.21 15 18 16.79 18 19V21" 
        stroke="url(#people-gradient)" 
        strokeWidth="2" 
        strokeLinecap="round"
        filter="url(#people-glow)"
      />
      <circle cx="18" cy="7" r="2" stroke="url(#people-gradient)" strokeWidth="1.5" opacity="0.6" />
      <path 
        d="M20 15.5C21.38 15.92 22 16.57 22 18V21" 
        stroke="url(#people-gradient)" 
        strokeWidth="1.5" 
        strokeLinecap="round" 
        opacity="0.6"
      />
      <circle cx="6" cy="7" r="2" stroke="url(#people-gradient)" strokeWidth="1.5" opacity="0.6" />
      <path 
        d="M4 15.5C2.62 15.92 2 16.57 2 18V21" 
        stroke="url(#people-gradient)" 
        strokeWidth="1.5" 
        strokeLinecap="round" 
        opacity="0.6"
      />
    </svg>
  )
}

export default PeopleIcon
